import { Component } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FormbuilderService } from "src/app/services/formbuilder.service";
import $ from 'jquery';
import { SharedService } from "src/app/services/shared.service";
declare var $: any;
import { Subscription } from 'rxjs';

@Component({
	selector: 'add-new-item-to-form',
	templateUrl: 'add-new-item-to-form.component.html',
})
export class AddNewItemToFormComponent {

	// addElementEvent: Subscription;

	public dialog: MatDialog;
	constructor(
		// public dialogRef: MatDialogRef<AddNewItemToFormComponent>,
		private _formBuilderService: FormbuilderService,
		private _sharedService: SharedService
	) {}

	onNoClick(){
		// this.dialogRef.close();
	}

	addSingleLineText(oldElement?){
		let jsonElement = {
			"label": "",
			"placeholder": "",
			"autofocus": false,
			"visible": true,
			"validate": {
				"required": true,
				"minLength": 4,
				"maxLength": 8
			},
			"key": "",
			"type": "text",
			"dataPlaceholder": ""
		};
		let isOldElement = oldElement ? true : false;
		let template = this.getNodes(this._formBuilderService.getTextField(jsonElement, isOldElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;
		// If clicked on to replace the element
		if(oldElement) {
			$("#"+ oldElement).replaceWith(template)

			let elementId = "#" + fieldId;
			let element = $(elementId);

			// element[0].children[2].children[2].innerText = "Single Line Text";
			// $(elementId + ' :input').attr('outerText', "Single Line Text");
			// $(elementId + ' :input').attr('data-placeholder', "Single Line Text");
			// $(elementId + ' :input').attr('data-label', "Single Line Text");
		} else {
			// If clicked on Add New Item
			$('.page').append(template);

			let elementId = "#" + fieldId;
			let element = $(elementId);

			element[0].children[2].children[2].innerText = "";
			element[0].children[1].setAttribute("contentEditable", "true");
			$(elementId + ' :input').attr('outerText', "");
			$(elementId + ' :input').attr('data-placeholder', "");
			$(elementId + ' :input').attr('data-label', "");
		}
		// this.dialogRef.close({ id: fieldId, type: "text"});
		
		return fieldId

		
		// this.dialogRef.close({ id: fieldId, type: "text"});
	}

	addEmailField(oldElement?){
		let jsonElement = {
			"label": "Email",
			"placeholder": "Email",
			"autofocus": false,
			"visible": true,
			"validate": {
				"required": true,
				"minLength": 4,
				"maxLength": 40
			},
			"key": "",
			"type": "email",
			"dataPlaceholder": "Email"
		};
		let template = this.getNodes(this._formBuilderService.getEmailField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Email";
		$(elementId + ' :input').attr('outerText', "Email");
		$(elementId + ' :input').attr('data-placeholder', "Email");
		$(elementId + ' :input').attr('data-label', "Email");
		$(elementId + ' :input').attr("disabled", true);
		setTimeout(() => {
			$(elementId + ' :input').removeAttr("disabled");
			this.selectLabelText($(elementId + ' :input')[0])
		}, 400)
		//
		return fieldId
		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "email" });
	}

	addPhoneField(oldElement?){
		let jsonElement = {
			"label": "Phone",
			"placeholder": "Phone",
			"autofocus": false,
			"visible": true,
			"validate": {
				"required": true,
				"minLength": 4,
				"maxLength": 20
			},
			"key": "",
			"type": "phone",
			"dataPlaceholder": "Phone"
		};
		let template = this.getNodes(this._formBuilderService.getPhoneField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Phone";
		$(elementId + ' :input').attr('outerText', "Phone");
		$(elementId + ' :input').attr('data-placeholder', "Phone");
		$(elementId + ' :input').attr('data-label', "Phone");
		this.selectLabelText($(elementId + ' :input')[0])
		
		return fieldId

		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "phone" });
	}

	addMultiLineText(oldElement?): any {
		let jsonElement = {
			"label": "Text Box",
			"placeholder": "Text Box",
			"autofocus": false,
			"visible": true,
			"validate": {
				"required": true,
				"minLength": 8,
				"maxLength": 180
			},
			"key": "",
			"type": "textarea",
			"dataPlaceholder": "Text Box"
		};
		let template = this.getNodes(this._formBuilderService.getTextAreaField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Text Box";
		$(elementId + ' :input').attr('outerText', "Text Box");
		$(elementId + ' :input').attr('data-placeholder', "Text Box");
		$(elementId + ' :input').attr('data-label', "Text Box");
		this.selectLabelText($(elementId + ' :input')[0])
		
		return fieldId
    
		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "textarea"});
	}

	addOptionsButton(oldElement?){
		let jsonElement = {
			"label": "Options Buttons",
			"placeholder": "Options Buttons",
			"autofocus": false,
			"visible": true,
			"key": "",
			"type": "radio",
			"validate": {
				"required": true
			},
			"data": [
				{
					label: "Option 1",
					visible: true,
					value: "option 1"
				}
			],
			"dataPlaceholder": "Options Buttons"
		}
		let template = this.getNodes(this._formBuilderService.getRadioField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Options Buttons";
		$(elementId + ' :input').attr('outerText', "Options Buttons");
		$(elementId + ' :input').attr('data-placeholder', "Options Buttons");
		$(elementId + ' :input').attr('data-label', "Options Buttons");
		this.selectLabelText($(elementId + ' :input')[0])
		
		return fieldId

		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "radio"});
	}

	addCheckBoxButton(oldElement?){
		let jsonElement = {
			"label": "Check Boxes",
			"placeholder": "",
			"visible": true,
			"key": "",
			"type": "checkbox",
			"validate": {
				"required": true
			},
			"defaultValue": "false",
			"dataPlaceholder": "Check Boxes"
		}
		let template = this.getNodes(this._formBuilderService.getCheckBoxField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Check Boxes";
		$(elementId + ' :input').attr('outerText', "Check Boxes");
		$(elementId + ' :input').attr('data-placeholder', "Check Boxes");
		$(elementId + ' :input').attr('data-label', "Check Boxes");
		
		return fieldId

		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "checkbox"});
	}

	addDropDownBox(oldElement?){
		let jsonElement = {
			"label": "Dropdown Box",
			"placeholder": "Dropdown Box",
			"visible": true,
			"key": "",
			"type": "select",
			"validate": {
				"required": true
			},
			"defaultValue": false,
			"data": [
				{
					label: "Option 1",
					visible: true,
					value: "option 1"
				}
			],
			"dataPlaceholder": "Dropdown Box"
		}
		let template = this.getNodes(this._formBuilderService.getDropDownField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Dropdown Box";
		$(elementId + ' :input').attr('outerText', "Dropdown Box");
		$(elementId + ' :input').attr('data-placeholder', "Dropdown Box");
		$(elementId + ' :input').attr('data-label', "Dropdown Box");
		this.selectLabelText($(elementId + ' :input')[0])
		
		return fieldId

		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "select"});
	}

	addPictureUpload(oldElement?){
		let jsonElement = {
			"label": "Picture Upload",
			"placeholder": "Picture Upload",
			"visible": true,
			"key": "",
			"type": "picture",
			"validate": {
				"required": true
			},
			"data": [],
			"dataPlaceholder": "Picture Upload"
		}
		let template = this.getNodes(this._formBuilderService.getPictureUploadField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Picture Upload";
		$(elementId + ' :input').attr('outerText', "Picture Upload");
		$(elementId + ' :input').attr('data-placeholder', "Picture Upload");
		$(elementId + ' :input').attr('data-label', "Picture Upload");
		this.selectLabelText($(elementId + ' :input')[0])
		
		return fieldId

		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "picture"});
	}

	addFileUpload(oldElement?){
		let jsonElement = {
			"label": "File Upload",
			"placeholder": "File Upload",
			"visible": true,
			"key": "",
			"type": "file",
			"validate": {
				"required": true
			},
			"data": [],
			"dataPlaceholder": "File Upload"
		}
		let template = this.getNodes(this._formBuilderService.getFileUploadField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "File Upload";
		$(elementId + ' :input').attr('outerText', "File Upload");
		$(elementId + ' :input').attr('data-placeholder', "File Upload");
		$(elementId + ' :input').attr('data-label', "File Upload");
		this.selectLabelText($(elementId + ' :input')[0])
		
		return fieldId

		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "file"});
	}

	addQuestion(oldElement?) {
		let jsonElement = {
			"label": "Yes/No Buttons",
			"placeholder": "Yes/No Buttons",
			"visible": true,
			"key": "",
			"type": "question",
			"validate": {
				"required": true
			},
			"data": [
				{
					"label": "Yes",
					"value": true,
					"visible": true
				},
				{
					"label": "No",
					"value": false,
					"visible": true
				}
			],
			"dataPlaceholder": "Yes/No Buttons"
		}
		let template = this.getNodes(this._formBuilderService.getQuestionField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId

		$("#"+ oldElement).replaceWith(template)
		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Yes/No Buttons";
		$(elementId + ' :input').attr('outerText', "Yes/No Buttons");
		$(elementId + ' :input').attr('data-placeholder', "Yes/No Buttons");
		$(elementId + ' :input').attr('data-label', "Yes/No Buttons");
		this.selectLabelText($(elementId + ' :input')[0])
		
		return fieldId

		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "question"});
	}

	addContact(oldElement?) {
		let jsonElement = {
			"label": "Would you like to be contacted about this submission?",
			"placeholder": "Would you like to be contacted about this submission?",
			"visible": true,
			"key": "",
			"type": "contact",
			"validate": {
				"required": true
			},
			"dataPlaceholder": "Would you like to be contacted about this submission?"
		}
		let template = this.getNodes(this._formBuilderService.getContactField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Would you like to be contacted about this submission?";
		$(elementId + ' :input').attr('outerText', "Would you like to be contacted about this submission?");
		$(elementId + ' :input').attr('data-placeholder', "Would you like to be contacted about this submission?");
		$(elementId + ' :input').attr('data-label', "Would you like to be contacted about this submission?");
		this.selectLabelText($(elementId + ' :input')[0])
		
		return fieldId
		// $('.page').append(template);
		// this.dialogRef.close();
	}

	addAddress(oldElement?): any {
		let jsonElement = {
			"label": "Address",
			"placeholder": "Address",
			"autofocus": false,
			"visible": true,
			"validate": {
				"required": true
			},
			"key": "",
			"type": "address",
			"dataPlaceholder": "Address"
		};
		let template = this.getNodes(this._formBuilderService.getAddressField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Text Box";
		$(elementId + ' :input').attr('outerText', "Address");
		$(elementId + ' :input').attr('data-placeholder', "Address");
		$(elementId + ' :input').attr('data-label', "Address");
		this.selectLabelText($(elementId + ' :input')[0])
		
		return fieldId
    
		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "textarea"});
	}

	addDate(oldElement?): any {
		let jsonElement = {
			"label": "Date",
			"placeholder": "Date",
			"autofocus": false,
			"visible": true,
			"validate": {
				"required": true
			},
			"key": "",
			"type": "date",
			"format": "mm/dd/yyyy",
			"dataPlaceholder": "Date"
		};
		let template = this.getNodes(this._formBuilderService.getDateField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Text Box";
		$(elementId + ' :input').attr('outerText', "Date");
		$(elementId + ' :input').attr('data-placeholder', "Date");
		$(elementId + ' :input').attr('data-label', "Date");
		this.selectLabelText($(elementId + ' :input')[0])
		
		return fieldId
    
		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "textarea"});
	}

	addTime(oldElement?): any {
		let jsonElement = {
			"label": "Time",
			"placeholder": "Time",
			"autofocus": false,
			"visible": true,
			"validate": {
				"required": true
			},
			"key": "",
			"type": "time",
			"format": "hh:mm A",
			"dataPlaceholder": "Time"
		};
		let template = this.getNodes(this._formBuilderService.getTimeField(jsonElement).template);
		let fieldId = "field-" + this.generateRandomString();
        template[0]["id"] = fieldId;

		$("#"+ oldElement).replaceWith(template)

		let elementId = "#" + fieldId;
		let element = $(elementId);
		// element[0].children[2].children[2].innerText = "Text Box";
		$(elementId + ' :input').attr('outerText', "Time");
		$(elementId + ' :input').attr('data-placeholder', "Time");
		$(elementId + ' :input').attr('data-label', "Time");
		this.selectLabelText($(elementId + ' :input')[0])
		// 
		return fieldId
    
		// $('.page').append(template);
		// this.dialogRef.close({ id: fieldId, type: "textarea"});
	}
	addEmptyField(beforeElement) {
		let template = this.getNodes(this._formBuilderService.getEmptyField())
		let fieldId = "emptyfield-" + this.generateRandomString();
        template[0]["id"] = fieldId
		$(template).insertBefore("#" + beforeElement)
		// ;
		return fieldId;
		// $('.page').append(template);
	}
	// Method will take the Html String and returns Arrays of DOM (take first element)
	getNodes(template) {
		return new DOMParser().parseFromString(template, "text/html").body.childNodes;
	}

	// Generate random string - (fields)
	generateRandomString() {
		return new Date().getTime();
	}

	isFormElementAvailable(element) {
		return this._sharedService.isFormElementAvailable(element)
	}
	selectLabelText(element) {
		if(element && element.type == "text") {
			element.focus();
			element.select();
		}
	}
}